/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react';

import Shake from 'components/animations/shake';
import './text-input.scss';

type TextInputProps = Partial<{
  label: string;
  info: string;
  error: boolean;
  readonly: boolean;
  registerRef: (arg: any) => void;
  hidden?: boolean;
  className?: string;
}> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      id,
      label,
      info,
      placeholder,
      error,
      registerRef,
      name,
      type = 'text',
      maxLength = undefined,
      readonly,
      readOnly,
      required,
      value,
      onChange,
      hidden = false,
      className,
    },
    ref,
  ) => {
    return (
      <Shake on={!!error} className={`${hidden ? 'hidden' : ''} ${className}`}>
        <div className='text-input'>
          {label && (
            <label htmlFor={name}>
              {label}
              <span className='info'>{info}</span>
            </label>
          )}
          <input
            {...{
              id,
              name,
              type,
              placeholder,
              readOnly: readonly ?? readOnly,
              maxLength,
              required,
              value,
              onChange,
            }}
            className={error ? 'error' : ''}
            ref={ref ?? registerRef}
          />
        </div>
      </Shake>
    );
  },
);

export default TextInput;
